import React from 'react'
import SectionBlock from '../section-block'
import Button from '../button/button-link.js'
import {
  ColorToHex,
  renderImageUrl,
  renderAsText,
  renderAsHtml,
  filterArrayByType,
} from '../../utility.js'
import * as styles from './call-out-block.module.css'
import { linkResolver } from '../../linkResolver'

export default ({ body }) => {
  let blocks = filterArrayByType(body, 'detailed_callout')

  if (blocks.length === 0) {
    return null
  }

  return blocks?.map((d) => {
    let style, styleImage

    console.log('detailed_callout', d)

    const isIcon = (d.items[0].image_type !== null && d.items[0].image_type);
    console.log(isIcon);

    let dataItems = d.items.slice(0, 3)

    blocks = dataItems?.map((block, i) => {
      style = {
        backgroundColor: ColorToHex(block.color),
      }

      let link = linkResolver(block.link || block.second_link || block.cta || block.cta1)
      let image = block.image || block.image1

      // console.log(linkResolver(block.link))

      // PULL IMAGE FROM LINKED DETAIL PAGE
      if (link) {
        if (
          link.hasOwnProperty('wide_image') ||
          link.hasOwnProperty('tall_image')
        ) {
          if (
            dataItems.length >
            2 /*|| window.matchMedia('(max-width: 500px)').matches*/
          ) {
            image = link.wide_image['home_feature_small']
          } else {
            image = link.tall_image['section_callout_tall']
          }
        }
      }
      styleImage = {
        backgroundImage: `url(${renderImageUrl(image)})`,
      }

      return (
        <div
          className={`col-lg-${12 / dataItems.length} ${styles.boxContainer}`}
          key={i}
        >
          <div
            className={dataItems.length > 2 ? styles.boxMobile : styles.box}
            style={style}
          >
            {!isIcon ? (
              <div
                className={
                  dataItems.length > 2 ? styles.boxImageMobile : styles.boxImage
                }
                style={styleImage}
              ></div>
            ) : (
              <div
                className={
                  `${dataItems.length > 2 ? styles.boxImageMobile : styles.boxImage} ${styles.boxImageIcon}`
                }
              >
                <img src={renderImageUrl(image)} alt={image.alt} />
              </div>
            )}
            <div
              className={
                dataItems.length > 2
                  ? styles.boxContentMobile
                  : styles.boxContent
              }
            >
              <div>
                <h3 className={styles.boxTitle}>
                  {renderAsText(block.title?.text || block.title1?.text)}
                </h3>
                <div className={styles.boxDescription}>
                  {renderAsHtml(
                    block.text?.text ||
                    block.body_text?.richText ||
                    block.text1?.richText ||
                    block.body_text
                  )}
                </div>
              </div>
              <div>
                {(block.cta_label || block.button_label) && (
                  <div>
                    <Button
                      text={block.cta_label || block.button_label}
                      link={link}
                      color={block.color}
                      isInverse={true}
                    />
                  </div>
                )}
                {block.second_cta_label && (
                  <div className="mt-2">
                    <Button
                      text={block.second_cta_label}
                      link={block.second_link}
                      color={block.color}
                      isInverse={true}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )
    })

    return (
      <SectionBlock>
        <div className="container">
          <div className="row">
            <div className="col-md-10 offset-md-1">
              <div className="row">{blocks}</div>
            </div>
          </div>
        </div>
      </SectionBlock>
    )
  })
}
